<template>
  <v-navigation-drawer v-model="drawer" app class="bg-primary">
    <v-card class="mx-auto bg-primary text-white" max-width="300" flat="">
      <v-list density="compact">
        <h2 class="ml-5 mt-3 mb-0">Menu</h2>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          class="mb-3"
          :to="item.route"
        >
          <template v-slot:prepend>
            <v-icon :icon="item.icon" />
          </template>

          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-navigation-drawer>


  <v-app-bar
    app
    flat
    class=" text-white nav-bar"
    :class="{'bg-transparent': scrollPosition < 310, change_color: scrollPosition > 310 }"
  >
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

    <v-toolbar-title>
      <v-icon class="px-10 text-h3">mdi-nature-people</v-icon>
      <span class="brand-name">Drive</span>
      <span class="text-pink font-weight-light brand-name">On</span>
    </v-toolbar-title>

    <v-btn icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

    <v-btn icon>
      <v-icon color="red">mdi-heart</v-icon>
    </v-btn>

    <v-btn icon>
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>

export default {
  data() {
    return {
      drawer: false,
      items: [
        {
          id: 1,
          title: "Home",
          icon: "mdi-home-city",
          route: "/",
        },
        {
          id: 2,
          title: "About us",
          icon: "mdi-book-information-variant",
          route: "/aboutus",
        },
        {
          id: 3,
          title: "Get Started",
          icon: "mdi-file-document-multiple",
          route: "/#getstart",
        },
        {
          id: 4,
          title: "Our Service",
          icon: "mdi-toolbox-outline",
          route: "/#service",
        },
        {
          id: 5,
          title: "Contact Us",
          icon: "mdi-card-account-mail",
          route: "/#contactus",
        },
        {
          id: 6,
          title: "User Managment",
          icon: "mdi-account-tie",
          route: "/user",
        },
      ],
      scrollPosition: null,
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap");
.brand-name {
  font-family: "Abril Fatface", cursive;
}
.change_color {
  transition: all 0.5s;
  background-color: #442697;
}
</style>